module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-grid m-div-table__holder-section"
  }, [_c('div', {
    staticClass: "flex-grid__g-3 hide"
  }, [_c('h3', {
    staticClass: "heading"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v("\n        " + _vm._s(_vm.subtitle) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__g-3"
  }, [_c('h2', {
    staticClass: "heading"
  }, [_vm._v("Benefit Amount")]), _vm._v(" "), _c('control', {
    attrs: {
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.amount),
      expression: "amount",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control.required",
      value: ({
        type: 'number'
      }),
      expression: "{type: 'number'}",
      modifiers: {
        "required": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "min": "0.00",
      "name": _vm.fieldName + '_value',
      "type": "number"
    },
    domProps: {
      "value": (_vm.amount)
    },
    on: {
      "focus": function($event) {
        _vm.amount = _vm.amount || ''
      },
      "blur": [function($event) {
        _vm.amount = _vm.amount || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.amount = _vm._n($event.target.value)
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error(_vm.fieldName + '_value')
    }
  }, [_vm._v("\n                The amount cannot be below 0 and must be a number.\n            ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__g-3"
  }, [_c('h2', {
    staticClass: "heading"
  }, [_vm._v("Deduction")]), _vm._v(" "), _c('control', {
    attrs: {
      "table-control": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.include),
      expression: "include"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.include = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No")])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-598fe0a0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/fatal-accident-claims/cru-benefits/Benefit.vue
// module id = 1707
// module chunks = 0